import type { IconSvgObject } from './types';

const Select01Icon: IconSvgObject = [
  ["path", { d: "M22 19V20C22 21.1046 21.1046 22 20 22H19M8 22H7C5.89543 22 5 21.1046 5 20V19M19 5H20C21.1046 5 22 5.89543 22 7V8M12.5 22H14.5M5 12.5V14.5M12.5 5H14.5M22 12.5V14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 2V8M2 5H8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Select01Icon;
